module.exports = __webpack_public_path__ + "img/draw_open.a1edeb54.gif";